import { Dispatcher } from "flux";
const ExtenderDispatcher = new Dispatcher();
export default ExtenderDispatcher;
